import { http } from "@/http";

export default {
  list(params) {
    return http.get("/api/v1/admin/coupon", { params });
  },
  get(id) {
    return http.get(`/api/v1/admin/coupon/${id}`);
  },
  save(payload) {
    return http.post("/api/v1/admin/coupon", payload);
  },
  update(id, payload) {
    return http.put(`/api/v1/admin/coupon/${id}`, payload);
  },
  toggleStatus(id, isActive) {
    return http.put(`/api/v1/admin/coupon/${id}/status`, null, {
      params: {
        isActive
      }
    });
  },
  delete(id) {
    return http.delete(`/api/v1/admin/coupon/${id}`);
  },
  download(params) {
    return http.get('/api/v1/admin/coupon/xlsx', {
      responseType: 'blob',
      params
    })
  },
  // Endpoint del store (público); útil para probar un cupón desde el admin
  validate(payload) {
    return http.post("/api/v1/coupon/validate", payload);
  }
};
